import React from 'react'
import Banner from './Banner'
import AerobottOverview from './AerobottOverview'
import FLYTITrainingSection from './TrainSmarterSection '
const ProductMain = () => {
  return (
    <div>
    <Banner />
      <AerobottOverview />
      <FLYTITrainingSection />
    </div>
  )
}

export default ProductMain;
